export default "__VITE_ASSET__f46ee059__"